import { render, staticRenderFns } from "./HeadUser.vue?vue&type=template&id=777c8c5c&"
import script from "./HeadUser.vue?vue&type=script&lang=js&"
export * from "./HeadUser.vue?vue&type=script&lang=js&"
import style0 from "./HeadUser.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports